// this implementation does not support lodash placeholders
export const partial = (func: any, ...params: any[]) => {
    return (...rest: any[]) => {
        return func(...params, ...rest);
    };
};
